// Who gets a page tour without asking, and what this device remembers about
// it. Kept apart from usePageTour so it can be tested without driver.js.
//
// A tour runs on its own for demo visitors and for accounts created once the
// tours existed. Managers who were already playing know these pages, so theirs
// stay off until they choose "Show tutorial" in the settings menu. The "?" in
// the nav bar replays the page on screen for anyone, either way.
//
// Everything is per device, in localStorage. Storage can be unavailable (a
// private window, blocked site data): a new account then sees each tour on
// every visit, and an older one keeps the "?".

const VERSION = 1;

// Accounts created before this are the existing managers. It only has to sit
// at or before the release that carries the tours: an account created between
// the two is days old and is shown them, which is the right answer anyway.
export const TOURS_LAUNCHED_AT = Date.parse("2026-10-01T00:00:00Z");

const MEMBER_PREFIX = "tour:member:";
const OPT_IN_KEY = "tour:optin";

export const seenKey = (page, demo) => `tour:${demo ? "demo" : "member"}:${page}:v${VERSION}`;

export function hasSeen(key) {
  try { return window.localStorage.getItem(key) === "1"; } catch { return false; }
}

export function markSeen(key) {
  try { window.localStorage.setItem(key, "1"); } catch { /* unavailable */ }
}

function hasOptedIn() {
  try { return window.localStorage.getItem(OPT_IN_KEY) === "1"; } catch { return false; }
}

// createdAt is users.created_at. Missing means the profile has not loaded (or
// there is none), and that is not treated as new: a tour that starts and then
// turns out to belong to a three-year manager cannot be taken back.
export function toursRunUnprompted({ demo, createdAt }) {
  if (demo) return true;
  if (hasOptedIn()) return true;
  const created = createdAt ? Date.parse(createdAt) : NaN;
  return Number.isFinite(created) && created >= TOURS_LAUNCHED_AT;
}

// "Show tutorial": every member tour is due again on this device, including
// for an account that predates them.
export function turnOnTours() {
  try {
    const { localStorage } = window;
    const stale = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(MEMBER_PREFIX)) stale.push(key);
    }
    stale.forEach((key) => localStorage.removeItem(key));
    localStorage.setItem(OPT_IN_KEY, "1");
  } catch { /* unavailable */ }
}
